<template>
  <div class="certificate">
    <div class="certificate__label">Geraçao do certificado</div>

    <div class="certificate__buttons">
      <SecondaryButton
        @click="redirectToCertificate"
      >Abrir agora</SecondaryButton>

      <TextButton
        @click="sendCertificateByEmail"
        v-if="!isCertificateGenerated"
      >E-mail</TextButton>

      <div v-else class="certificate__feedback">
          Certificado enviado para seu e-mail.
      </div>
    </div>
  </div>
</template>

<script>
import SecondaryButton from '@/components/buttons/SecondaryButton';
import TextButton from '@/components/buttons/TextButton';
import { mapMutations, mapActions } from 'vuex';
import { sendEmailCertificate } from '@/api/certificate.api.js'

export default {
  components: {
    SecondaryButton,
    TextButton,
  },

  props: {
    course: { type: Object, required: true }
  },

  data: () => ({
    isCertificateGenerated: false,
  }),

  methods: {
    ...mapMutations('app', ['setLoading']),

    ...mapActions('course', ['generateCourseCertificate']),

    async redirectToCertificate() {
      this.setLoading(true)

      const certificateUrl = await this.generateCourseCertificate(this.course)

      this.setLoading(false)

      window.open(certificateUrl)
    },

    async sendCertificateByEmail() {
      this.isCertificateGenerated = true

      await this.generateCourseCertificate()

      await sendEmailCertificate(this.course.id)
    },
  }
}
</script>

<style lang="scss" scoped>
  .certificate {
    border-top: 1px solid rgba(#000, .1);
    padding-top: 16px;
    margin-top: 16px;

    &__label {
      margin-bottom: 6px;
      font-size: 0.89rem;
    }    

    &__buttons {
      display: flex;
      gap: 4px;

      & > * {
        flex: 1 1 50%;
        padding-left: 0;
        padding-right: 0;
      }
    }

    &__feedback {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 15px;
      line-height: 18px;
      color: #080;
      text-align: center;
    }
  }
</style>